<template>
	<header :class="{ var_collapsed: !state, var_show: forceShow }">
		<!-- <transition name="fade"> -->
		<div class="menu_wrapper" ref="menuWrapper" v-show="showMenu">
			<ul id="menu" class="menu" v-if="menu" :key="menu[0].ID">
				<li
					v-for="item in menu"
					:key="`${item.ID}`"
					:class="{ is_active: isActive(item.url) }"
					@mouseenter="onPointerMouseEnter($event, 'text')"
					@mouseleave="onPointerMouseLeave($event, 'text')"
				>
					<router-link :to="item.url | clearUrl">
						<span>{{ item.title }}</span>
					</router-link>
				</li>
				<li v-if="translatedDonation">
					<a
						:href="translatedDonation"
						@mouseenter="onPointerMouseEnter($event)"
						@mouseleave="onPointerMouseLeave($event)"
						target="_blank"
						class="badge"
					>
						<IconBadge :lang="currentLanguage" />
					</a>
				</li>
			</ul>
		</div>
		<!-- </transition> -->
		<div ref="buttons">
			<button
				type="button"
				class="umbrella"
				@click="toggleMenu"
				@mouseenter="onPointerMouseEnter"
				@mouseleave="onPointerMouseLeave"
			>
				<IconUmbrella />
			</button>

			<button
				type="button"
				class="back"
				@click="() => this.$router.push(`${redirectLang}`)"
				@mouseenter="onPointerMouseEnter"
				@mouseleave="onPointerMouseLeave"
			>
				<IconArrow fill="#000" />
				<span>HOME</span>
			</button>
		</div>

		<span class="overlay" @click="forceShow = false"></span>
		<span class="menu_blob"></span>
	</header>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import IconArrow from "@/components/icons/IconArrow";
import EventBus from "@/helpers/event-bus";
import IconUmbrella from "@/components/icons/IconUmbrella";
import IconBadge from "@/components/icons/IconBadge";

import PointerHoverMixin from "@/mixins/pointerHover";

export default {
	name: "TheHeader",
	mixins: [PointerHoverMixin],
	components: {
		IconArrow,
		IconBadge,
		IconUmbrella,
	},
	props: {
		showMenu: {
			type: Boolean,
			default: true,
		},
	},
	data() {
		return {
			scrolled: 0,
			state: 1,
			forceShow: false,
		};
	},
	computed: {
		...mapState("site", {
			currentLanguage: (state) => state.currentLanguage,
			defaultLanguage: (state) => state.defaultLanguage,
			donation: (state) => state.donation,
		}),
		...mapState("page", ["currentPageSlug"]),
		...mapGetters("site", ["menu"]),
		redirectLang() {
			return this.currentLanguage === this.defaultLanguage ? "/" : `/${this.currentLanguage}`;
		},
		translatedDonation() {
			return this.donation[this.currentLanguage];
		},
	},
	created() {
		window.addEventListener("scroll", this.onScroll);
	},
	methods: {
		toggleMenu() {
			this.forceShow = !this.forceShow;
		},
		onScroll() {
			requestAnimationFrame(() => {
				this.scrolled = window.scrollY;
				this.checkMenuState();
			});
		},
		checkMenuState() {
			const mql = window.matchMedia("(min-width: 421px)");
			const top = mql.matches ? window.innerHeight * 0.4 : 10;
			if (this.scrolled > top) {
				if (this.state === 0) return true;
				this.state = 0;
				this.forceShow = false;
			} else {
				if (this.state === 1) return true;
				this.state = 1;
			}
		},
		isActive(url) {
			if (!url || !this.currentPageSlug) {
				return false;
			}

			const slug = this.currentPageSlug.replace("_", "/");
			const isExist = url.search(slug);

			return isExist !== -1;
		},
		split(value) {
			const arr = value.split("");
			const newText = arr.reduce((acc, cv) => acc + `<span>${cv}</span>`, "");
			return `${newText}`;
		},
	},
	watch: {
		$route() {
			this.state = 1;
			this.forceShow = false;
		},
		currentLanguage() {
			EventBus.$emit(EventBus.menu.reinit);
		},
	},
	filters: {
		wrapInSpan(value) {
			const arr = value.split("");
			const newText = arr.reduce((acc, cv) => acc + `<span>${cv}</span>`, "");
			return `${newText}`;
		},
	},
};
</script>

<style scoped lang="scss">
$time: 0.4s;
@keyframes border1 {
	0% {
		border-radius: 50% 100% 70% 60% / 80% 70% 80% 60%;
		// transform: scale(1)
	}

	33% {
		border-radius: 80% 70% 80% 70% / 80% 70% 100% 70%;
		// transform: scale(1.2)
	}

	66% {
		border-radius: 100% 50% 70% 90% / 90% 100% 60% 80%;
		// transform: scale(1.4)
	}

	100% {
		border-radius: 50% 100% 70% 60% / 80% 70% 80% 60%;
	}
}

.menu {
	position: relative;
	list-style: none;
	padding: 0;
	transition: transform $time, opacity $time;
	transform: translateX(0);
	opacity: 1;
	z-index: 11;

	margin-top: -10px;

	@include mq($from: m) {
		margin-top: -12px;
	}

	@include mq($from: l) {
		margin-top: -13px;
	}

	@include mq($from: xl) {
		margin-top: -13px;
	}

	li {
		position: relative;

		a {
			transition: transform $time, opacity $time;
		}

		@for $i from 1 through 9 {
			&:nth-child(#{$i}) {
				a {
					transition-delay: 0.05s * $i;
				}
			}
		}

		&::v-deep span {
			display: inline-block;
			text-decoration: underline;
		}

		&:after {
			content: "";
			display: block;
			position: absolute;
			top: 0;
			left: -5%;
			width: 110%;
			height: 100%;
			// background: $colorBeige1;
			// background: blue;
			border-radius: 55% 65% 60% 70% / 70% 65% 60% 55%;
		}

		a {
			position: relative;
			z-index: 3;

			span {
				@include textUnderlineGradient;
				line-height: inherit;
			}

			&:hover {
				span {
					@include textUnderlineGradientHover;
				}
			}
		}

		.badge {
			@include mq($from: m) {
				transform: translate(-50%, 0);
			}
		}
	}

	li:first-child {
		a {
			// margin-top: 0;
		}
	}

	a {
		@include fontMenu();
		text-decoration: underline;
		display: inline-block;

		&.router-link-exact-active {
			span {
				text-decoration: none;
			}
		}
	}
}

.menu_wrapper {
	transition: max-height 0.5s;
	max-height: 100vh;

	.var_collapsed:not(.var_show) & {
		.var_page_page & {
			pointer-events: none;
		}
	}

	@include mq($to: m) {
		overflow: hidden;
	}
}

.menu_blob {
	display: block;
	position: absolute;
	top: -25%;
	left: -25%;
	z-index: 10;
	background: #fff;
	width: 150%;
	height: 150%;
	border-radius: 100%;
	border-radius: 50% 100% 70% 60% / 80% 70% 80% 60%;
	transform: scale(0);
	transform-origin: 20% 15%;
	transition: transform $time;
	transition-delay: 0.1s;
}

.overlay {
	position: absolute;
	top: -40px;
	left: 0px;
	width: 100px;
	height: 100px;
	background: rgba(255, 255, 255, 0.5);
	z-index: 10;
	opacity: 0;
	border-radius: 50%;
	transition: transform $time, opacity $time;
	transform-origin: 70% 30%;
}

.var_page_home {
	.back {
		transform: scale(0);
		opacity: 0;
	}

	.umbrella {
		transform: scale(0);
		opacity: 0;
	}

	.overlay {
		transform: scale(0);
		opacity: 0;
	}

	.menu_blob {
		transform: scale(0);
	}

	.menu {
		transform: translateX(0%);
		opacity: 1;
	}
}

.var_page_page {
	header {
		padding-top: 100px;
	}

	.var_show {
		.overlay {
			transform: scale(30);
			opacity: 1;
			cursor: url("data:image/svg+xml,%3Csvg version='1.1' id='Layer_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='22px' height='22px' viewBox='0 0 22 22' style='enable-background:new 00 0 0 0;' xml:space='preserve'%3E %3Cpath d='M1.61289944,0.310209676 L1.70710678,0.393398282 L11,9.68550506 L20.2928932,0.393398282 C20.6834175,0.00287399045 21.3165825,0.00287399045 21.7071068,0.393398282 C22.0675907,0.753882244 22.0953203,1.3211133 21.7902954,1.71340451 L21.7071068,1.80761184 L12.515,11 L21.7071068,20.1923882 C22.0675907,20.5528721 22.0953203,21.1201032 21.7902954,21.5123944 L21.7071068,21.6066017 C21.3466228,21.9670857 20.7793918,21.9948152 20.3871006,21.6897903 L20.2928932,21.6066017 L11,12.3135051 L1.70710678,21.6066017 C1.31658249,21.997126 0.683417511,21.997126 0.292893219,21.6066017 C-0.0675907428,21.2461178 -0.0953202783,20.6788867 0.209704612,20.2865955 L0.292893219,20.1923882 L9.485,11 L0.292893219,1.80761184 C-0.0675907428,1.44712788 -0.0953202783,0.879896827 0.209704612,0.48760562 L0.292893219,0.393398282 C0.65337718,0.0329143206 1.22060824,0.00518478508 1.61289944,0.310209676 Z'/%3E %3C/svg%3E"),
				pointer;
		}

		.menu_blob {
			transform: scale(1);
			transition: transform $time;
		}

		button.back {
			background: $colorGraphite;

			span {
				color: #fff;
			}

			&:hover {
				background: $colorRed1;
			}

			&::v-deep svg path {
				fill: #fff;
			}
		}
	}

	.var_collapsed:not(.var_show) {
		.menu_wrapper {
			max-height: 0;
		}

		.menu {
			li {
				a {
					transform: translateX(300px);
					opacity: 0;
				}

				@for $i from 1 through 7 {
					&:nth-child(#{$i}) {
						a {
							transition-delay: 0.05s * (7 - $i);
						}
					}
				}
			}
		}

		.back {
			transform: scale(0);
			opacity: 0;
		}

		.umbrella {
			transform: scale(1);
			opacity: 1;
		}
	}
}

header {
	position: relative;

	// &.var_collapsed:not(.var_show) {
	// 	height: 100px;
	// }
}

button {
	border: 0;
	background: #fff;
	box-shadow: none;
	appearance: none;
	-webkit-appearance: none;
	width: 65px;
	height: 62px;
	border-radius: 50% 100% 70% 60% / 80% 70% 80% 60%;
	position: absolute;
	top: 5px;
	left: 0;
	z-index: 11;
	outline: none;
	cursor: pointer;
	transition: background $time, transform $time, opacity $time;
	animation: border1 2s infinite linear;
	animation-play-state: paused;

	@include mq($from: m) {
		top: -20px;
	}

	@include mq($from: l) {
		top: -40px;
		width: 100px;
		height: 95px;
	}

	&::v-deep {
		svg path {
			transition: all $time;
		}
	}

	&:hover {
		animation-play-state: running;
	}

	&.back {
		display: flex;
		justify-content: center;
		align-items: center;
		transform: scale(1);

		svg {
			transform: rotate(180deg);
		}

		span {
			@include fontMenu;
			transition: color $time;
			font-size: 12px !important;
			line-height: 1;
			margin: 0 0 0 7px !important;
		}

		opacity: 1;

		&:hover {
			background: $colorRed1;

			span {
				color: #fff;
			}

			&::v-deep {
				svg path {
					fill: #fff;
				}
			}
		}
	}

	&.umbrella {
		transform: scale(0);
		opacity: 0;

		&:hover {
			background: $colorGraphite;
		}
	}
}
</style>
